/** @format */

//TODO: Remove eslint-disable and fix the error properly
/* eslint-disable react/no-string-refs */

import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Footer from '../components/Footer/Footer.jsx';
import login from 'assets/img/login.jpeg';
import CertificationPage from '../views/Pages/CertificationPage';
import pagesStyle from '../assets/jss/material-dashboard-pro-react/layouts/authStyle';
import oplAppStyle from '../assets/themes/OPL/jss/App/OplAppStyle';

export const Certificate = (props: { classes: any }): React.ReactElement => {
    const { classes } = props;

    return (
        <div>
            <div className={classes.loginWrapper}>
                <div className={classes.fullPage}>
                    <CertificationPage />
                    <Footer white />
                </div>
            </div>
        </div>
    );
};

export default withStyles(oplAppStyle)(Certificate);
